"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledModalClose = exports.ModalClose = void 0;

var _core = require("@emotion/core");

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _recompose = require("recompose");

var _styledSystem = require("styled-system");

var _emotionTheming = require("emotion-theming");

var _icon = _interopRequireDefault(require("../icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable jsx-a11y/no-autofocus */
var ModalClose = (0, _emotionTheming.withTheme)(function (props) {
  return (0, _core.jsx)("button", {
    onClick: props.closeModal,
    className: props.className,
    autoFocus: true
  }, (0, _core.jsx)(_icon.default, {
    width: "".concat(props.theme.spacing[4], "px"),
    icon: "close"
  }));
});
/* eslint-enable jsx-a11y/no-autofocus */

exports.ModalClose = ModalClose;
var StyledModalClose = (
/*#__PURE__*/
0, _styledBase.default)(ModalClose, {
  target: "e5epp5y0"
})("display:flex;align-items:center;justify-content:center;margin:0;padding:0;margin-right:-5px;max-width:", (0, _styledSystem.themeGet)('spacing.4'), "px;border-radius:3px;border:none;box-shadow:none;line-height:1.8;background:transparent;cursor:pointer;user-select:none;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out;&:active,&:focus,&:hover{box-shadow:none;background:transparent;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tb2RhbC9tb2RhbC1jbG9zZS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFnQmtEIiwiZmlsZSI6Ii4uLy4uL3NyYy9tb2RhbC9tb2RhbC1jbG9zZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xuaW1wb3J0IHsgY29tcG9zZSwgc2V0UHJvcFR5cGVzLCBzZXREaXNwbGF5TmFtZSB9IGZyb20gJ3JlY29tcG9zZSc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyB0aGVtZUdldCB9IGZyb20gJ3N0eWxlZC1zeXN0ZW0nO1xuaW1wb3J0IHsgd2l0aFRoZW1lIH0gZnJvbSAnZW1vdGlvbi10aGVtaW5nJztcbmltcG9ydCBJY29uIGZyb20gJy4uL2ljb24nO1xuXG4vKiBlc2xpbnQtZGlzYWJsZSBqc3gtYTExeS9uby1hdXRvZm9jdXMgKi9cbmV4cG9ydCBjb25zdCBNb2RhbENsb3NlID0gd2l0aFRoZW1lKHByb3BzID0+IChcbiAgPGJ1dHRvbiBvbkNsaWNrPXtwcm9wcy5jbG9zZU1vZGFsfSBjbGFzc05hbWU9e3Byb3BzLmNsYXNzTmFtZX0gYXV0b0ZvY3VzPXt0cnVlfT5cbiAgICA8SWNvbiB3aWR0aD17YCR7cHJvcHMudGhlbWUuc3BhY2luZ1s0XX1weGB9IGljb249XCJjbG9zZVwiLz5cbiAgPC9idXR0b24+XG4pKTtcbi8qIGVzbGludC1lbmFibGUganN4LWExMXkvbm8tYXV0b2ZvY3VzICovXG5cbmV4cG9ydCBjb25zdCBTdHlsZWRNb2RhbENsb3NlID0gc3R5bGVkKE1vZGFsQ2xvc2UpYFxuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgbWFyZ2luOiAwO1xuICBwYWRkaW5nOiAwO1xuICBtYXJnaW4tcmlnaHQ6IC01cHg7XG4gIG1heC13aWR0aDogJHt0aGVtZUdldCgnc3BhY2luZy40Jyl9cHg7XG4gIGJvcmRlci1yYWRpdXM6IDNweDtcbiAgYm9yZGVyOiBub25lO1xuICBib3gtc2hhZG93OiBub25lO1xuICBsaW5lLWhlaWdodDogMS44O1xuICBiYWNrZ3JvdW5kOiB0cmFuc3BhcmVudDtcbiAgY3Vyc29yOiBwb2ludGVyO1xuICB1c2VyLXNlbGVjdDogbm9uZTtcbiAgdHJhbnNpdGlvbjogY29sb3IgLjE1cyBlYXNlLWluLW91dCwgYmFja2dyb3VuZC1jb2xvciAuMTVzIGVhc2UtaW4tb3V0LCBib3JkZXItY29sb3IgLjE1cyBlYXNlLWluLW91dDtcbiAgJjphY3RpdmUsXG4gICY6Zm9jdXMsXG4gICY6aG92ZXIge1xuICAgIGJveC1zaGFkb3c6IG5vbmU7XG4gICAgYmFja2dyb3VuZDogdHJhbnNwYXJlbnQ7XG4gIH1cbmA7XG5cbmV4cG9ydCBkZWZhdWx0IGNvbXBvc2UoXG4gIHNldFByb3BUeXBlcyh7XG4gICAgY2xvc2VNb2RhbDogUHJvcFR5cGVzLmZ1bmMuaXNSZXF1aXJlZFxuICB9KSxcbiAgc2V0RGlzcGxheU5hbWUoJ01vZGFsQ2xvc2UnKVxuKShTdHlsZWRNb2RhbENsb3NlKTtcbiJdfQ== */"));
exports.StyledModalClose = StyledModalClose;

var _default = (0, _recompose.compose)((0, _recompose.setPropTypes)({
  closeModal: _propTypes.default.func.isRequired
}), (0, _recompose.setDisplayName)('ModalClose'))(StyledModalClose);

exports.default = _default;